import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;

export const getDashboardDetails = async () => {
  return axios
    .get(`${API_PREFIX}/dashboard`)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error?.response.data));
};

export const getDashboardDetailsById = async (id) => {
  return axios
    .get(`${API_PREFIX}/dashboard?id=${id}`)
    .then((res) => res.data)
    .catch((error) => Promise.reject(error?.response.data));
};

export const getDashboardDetailsByMinistryId = async (
  id,
  examDayId,
  rrb_id = null,
  incident_rrb = null
) => {
  return axios
    .get(
      `${API_PREFIX}/dashboard/super-admin-dashboard?ministry_exam_id=${id}&exam_day_id=${examDayId}&id=${rrb_id}&incident_rrb=${incident_rrb}`
    )
    .then((res) => res.data)
    .catch((error) => Promise.reject(error?.response.data));
};

export const getIncidentReport = async (filter) => {
  return axios
    .get(
      `${API_PREFIX}/dashboard/getIncidentReport?_page=${filter._page}&_limit=${filter._limit}&_sort=id&_order=desc&q=${filter.q}&ministry_exam_id=${filter.ministry_exam_id}`
    )
    .then((res) => res.data)
    .catch((error) => Promise.reject(error?.response.data));
};

export const removeIncident = async (id) => {
  return await axios
    .delete(`${API_PREFIX}/submissions_values/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
